import { Alert, AlertProps, Typography } from 'src/shared';
import { IconAlert, IconInfo, IconSuccess, IconWarning } from 'src/Assets/svg';
import { LoadingOutlined } from '@ant-design/icons';

interface IProps {
  message?: AlertProps['message'];
  type: AlertProps['type'];
  description?: AlertProps['description'];
  action?: AlertProps['action'];
  alertClassName?: string;
  isLoading?: boolean;
}

export const AlertNotification = ({ description, type = 'info', alertClassName, message, action, isLoading = false }: IProps) => {
  const { Paragraph } = Typography;

  const style = {
    info: 'info_message',
    error: 'error_message',
    success: 'success_message',
    warning: 'warning_message',
  };
  const icons = {
    info: <IconInfo size={24} />,
    error: <IconAlert size={24} />,
    success: <IconSuccess size={24} />,
    warning: <IconWarning size={24} />,
    loading: (
      <LoadingOutlined
        spin
        style={{ fontSize: 24 }}
      />
    ),
  };

  return (
    <Alert
      type={type}
      message={message ? <Paragraph className={`mb-0 ${style[type]} ${!message ? 'mt-0' : ''}`}>{message}</Paragraph> : null}
      description={description}
      showIcon
      icon={<div className="align-self-start mr-0 pr-3">{icons[isLoading ? 'loading' : type]}</div>}
      className={alertClassName}
      action={action}
    />
  );
};
